module.exports = __webpack_public_path__ + "static/media/teamwork.1770b5d1.jfif";